<template>
  <DSPopover
    :open="editing"
    hide-when-detached
  >
    <DSPopoverTrigger as-child>
      <slot />
    </DSPopoverTrigger>
    <DSPopoverContent class="p-1.75">
      <p class="text-xs font-medium mb-1 text-muted-foreground">
        Rename "{{ label }}"
      </p>
      <DSInputGroup size="sm">
        <DSInputGroupInput
          v-model="labelDraft"
          :placeholder="`Rename '${label}'`"
          :aria-label="`Rename '${label}'`"
          size="sm"
          class="max-w-30 pr-0.75!"
        />
        <DSInputGroupAddon
          align="inline-end"
          class="gap-0 pr-2"
        >
          <DSInputGroupButton
            variant="ghost"
            @click="handleSave"
          >
            <CheckIcon />
          </DSInputGroupButton>
          <DSInputGroupButton
            variant="ghost"
            @click="editing = false"
          >
            <XIcon />
          </DSInputGroupButton>
        </DSInputGroupAddon>
      </DSInputGroup>
    </DSPopoverContent>
  </DSPopover>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

import { DSInputGroup, DSInputGroupAddon, DSInputGroupButton, DSInputGroupInput, DSPopover, DSPopoverContent, DSPopoverTrigger } from '@ds'

import { CheckIcon, XIcon } from '@lucide/vue'

import { useFlyoutHoldOpen } from '@/components/DS/patterns/Sidebar/useFlyoutHoldOpen'

const props = defineProps<{
  label: string
}>()

const emit = defineEmits<{
  save: [value: string]
}>()

const editing = defineModel<boolean>()
useFlyoutHoldOpen(editing)

const labelDraft = ref(props.label)

const handleSave = () => {
  emit('save', labelDraft.value)
  editing.value = false
}

watch(editing, value => {
  if (!value) return
  labelDraft.value = props.label
})
</script>
